import { render } from "./assignments.vue?vue&type=template&id=0bfc61a2&scoped=true"
import script from "./assignments.vue?vue&type=script&lang=js"
export * from "./assignments.vue?vue&type=script&lang=js"

import "./assignments.vue?vue&type=style&index=0&id=0bfc61a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfc61a2"]])

export default __exports__